export default "__VITE_ASSET__uy6rzkQ$__"